import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProdutoEtapaModalidade } from '../models/produto-etapa-modalidade.model';

@Injectable()
export class ProdutoEtapaModalidadeService extends BaseService<ProdutoEtapaModalidade> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/produto-etapa-modalidade';
  }
}
